var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSelf1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1681_4203)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.31585 26.2504V7.10179H26.6901V26.2461C26.6904 26.3038 26.6793 26.3611 26.6573 26.4145C26.6353 26.4679 26.603 26.5165 26.5621 26.5573C26.5213 26.5982 26.4727 26.6305 26.4193 26.6525C26.3659 26.6745 26.3086 26.6856 26.2508 26.6854H3.75513C3.69737 26.6856 3.64012 26.6745 3.58669 26.6525C3.53327 26.6305 3.48473 26.5982 3.44388 26.5573C3.40303 26.5165 3.37068 26.4679 3.34871 26.4145C3.32673 26.3611 3.31556 26.3038 3.31585 26.2461V26.2504ZM0.101563 3.75036C0.101563 1.73607 1.73871 0.101074 3.75513 0.101074H26.2508C28.2694 0.101074 29.9044 1.73607 29.9044 3.75465V26.2504C29.9044 28.2689 28.2694 29.9039 26.2508 29.9039H3.75513C3.27526 29.9042 2.80004 29.8099 2.35664 29.6264C1.91324 29.4429 1.51036 29.1738 1.17104 28.8345C0.83172 28.4951 0.56261 28.0923 0.379101 27.6489C0.195592 27.2055 0.101281 26.7302 0.101563 26.2504V3.75036Z",
    fill: "url(#paint0_linear_1681_4203)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1681_4203",
    x1: 0.101563,
    y1: -3.62428,
    x2: 31.8729,
    y2: 31.1747,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2AABE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D6EB5"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1681_4203"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelf1);
export default __webpack_public_path__ + "static/media/Self1.bd998cc87e03958e010d4bb113994366.svg";
export { ForwardRef as ReactComponent };